import axios from 'axios';
import { REQUEST_URL } from '../config/urls';

const requisitar = () => {
  return {
    type: 'REQUISITAR_PUBLICACAO',
  };
};

const erro = (erro) => {
  return {
    type: 'ERRO_PUBLICACAO',
    erro,
  };
};

const obterEspecifico = (publicacao) => {
  return {
    type: 'OBTER_PUBLICACAO',
    publicacao,
  };
};

const removerPublicacao = (publicacao) => {
  return {
    type: 'REMOVER_PUBLICACAO',
    publicacao,
  };
};

const alterarPublicacao = (publicacao) => {
  return {
    type: 'EDITAR_PUBLICACAO',
    publicacao,
  };
};

const obterTodas = (publicacoes) => {
  return {
    type: 'OBTER_PUBLICACOES',
    publicacoes,
  };
};

export const obterPublicacao = (publicacao) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/publicacoes/findOne?filter={"where":{"id":${publicacao}}, "include": [{"paginas": ["comentarios"]}]}`
      )
      .then((response) => {
        dispatch(obterEspecifico(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const deletarPublicacao = (publicacao) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .delete(`${REQUEST_URL}/publicacoes/${publicacao}`)
      .then((response) => {
        dispatch(removerPublicacao(publicacao));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const editarPublicacao = (id, publicacao) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .patch(`${REQUEST_URL}/publicacoes/${id}`, publicacao)
      .then((response) => {
        dispatch(alterarPublicacao(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data ? error.response.data.error : error));
      });
  };
};

export const obterPublicacoesPeloContrato = (contrato) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/publicacoes/find?filter={"where":{"contrato":${contrato}}, "include": [{"paginas": ["comentarios"]}]}`
      )
      .then((response) => {
        dispatch(obterTodas(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};
export const obterUltimaPublicacaoPeloContrato = (contrato, tipo) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/publicacoes/find?filter={"where":{"contrato":${contrato},"tipo":${tipo}}, "include": [{"paginas": ["comentarios"]}]}`
      )
      .then((response) => {
        dispatch(obterTodas(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};
export const obterPublicacoesPeloTipo = (tipo, contrato) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/publicacoes?filter={"order": "dataPublicacao DESC", "where": {"and": [{"contrato": ${contrato}}, {"tipo": "${tipo}"}]}, "include": [{"paginas": ["comentarios"]}]}`
      )
      .then((response) => {
        dispatch({
          type: 'OBTER_PUBLICACOES',
          publicacoes: response.data,
        });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/PublicacaoActions.js